module.exports = __webpack_public_path__ + "static/media/valencia-16.54553eb9.jpg";